<div class="dialog ui-panel d-flex direction-column align-center" [formGroup]="rpa">
  <h1 class="dialog-title" mat-dialog-title>
    Informe uma mensagem para acompanhar o email de contrato <strong>RPA</strong>
  </h1>

  <app-c-input
    class="form-input dialog-field vw-100"
    formControlName="UserMsg"
    placeholder="Inserir Mensagem"
    inputType="textarea"
    label="Mensagem de e-mail:"
    [maxlength]="1000">
  </app-c-input>

  <div class="dialog-actions actions d-flex justify-center mt-36" mat-dialog-actions>
    <button class="actions-btn btn-confirm ui-btn ui-btn--primary" type="button" (click)="close(true)">Enviar</button>
    <button class="actions-btn btn-dismiss ml-16 ui-btn ui-btn--secondary" type="button" (click)="close(false)">Cancelar</button>
  </div>
</div>
